import { z } from 'zod';
import { toFlatField } from '../oasis-types';
import { bloodPressureValidation } from '../shared/blood-pressure-validation';
import { painSchema } from '../pain';
export const baseVitals = z.object({
    notChecked: z.boolean().optional(),
    temp: z.string().optional(),
    via: z.string().optional(),
});
export const baseVitalsRefined = baseVitals.refine((data) => data.notChecked || data.temp?.trim() || data.via?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseO2 = z.object({
    notChecked: z.boolean().optional(),
    o2Sat: z.string().optional(),
    flow: z.string().optional(),
    lpm: z.string().optional(),
    via: z.string().optional(),
    viaOther: z.string().optional(),
    resp: z.string().optional(),
    respReg: z.string().optional(),
    effort: z.string().optional(),
});
export const baseO2Refined = baseO2.refine((data) => data.notChecked ||
    data.o2Sat?.trim() ||
    data.flow?.trim() ||
    data.resp?.trim() ||
    data.respReg?.trim() ||
    data.effort?.trim() ||
    data.lpm?.trim() ||
    data.via?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const basePulse = z.object({
    notChecked: z.boolean().optional(),
    pulse: z.string().optional(),
    pulseApical: z.string().optional(),
    pulseReg: z.string().optional(),
    position: z.string().optional(),
});
export const basePulseRefined = basePulse.refine((data) => data.notChecked || data.pulse?.trim() || data.pulseApical?.trim() || data.pulseReg?.trim() || data.position?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseBloodSugar = z.object({
    notChecked: z.boolean().optional(),
    fasting: z.string().optional().nullable(),
    random: z.string().optional().nullable(),
    timeSinceLastMeal: z.string().optional().nullable(),
});
export const baseBloodSugarRefined = baseBloodSugar.refine((data) => data.notChecked || data.fasting?.trim() || data.random?.trim() || data.timeSinceLastMeal?.trim(), {
    message: 'At least one answer is required',
    path: [],
});
export const baseBloodPressure = z.object({
    notChecked: z.boolean().optional(),
    bloodPressures: z
        .array(z.object({
        systolic: z.string().optional(),
        diastolic: z.string().optional(),
        position: z.string().optional(),
        arm: z.string().optional(),
        option: z.string().optional(),
    }))
        .optional(),
});
export const baseBloodPressureRefined = bloodPressureValidation('notChecked', {
    checkboxLabel: 'Not Captured',
});
export const basePain = z.object({
    none: z.boolean().optional(),
    pains: z.array(painSchema).optional(),
});
export const basePainRefined = basePain.refine((data) => {
    const hasPains = data.pains && data.pains.length > 0;
    if (data.none === undefined && !hasPains) {
        return true;
    }
    return data.none || hasPains;
}, { message: 'At least one pain entry is required or check Denies/None', path: [] });
export const VitalsVersioned = {
    vitals: { e1: { alias: 'vitals', timepoint: ['soc', 'roc', 'rct', 'dsch'] } },
    o2: { e1: { alias: 'o2', timepoint: ['soc', 'tr', 'trd', 'rct', 'dsch'] } },
    pulseRespiration: { e1: { alias: 'pulseRespiration', timepoint: ['soc', 'tr', 'trd', 'rct', 'dsch'] } },
    bloodSugar: { e1: { alias: 'bloodSugar', timepoint: ['soc', 'tr', 'trd', 'rct', 'dsch'] } },
    bloodPressure: { e1: { alias: 'bloodPressure', timepoint: ['soc', 'roc', 'rct'] } },
};
export const Vitals = toFlatField(VitalsVersioned);
